// Shared by the Lucky 7 bet table and the virtual Lucky 7 view.
const CARD_VALUES = ["A", "2", "3", "4", "5", "6", "7", "8", "9", "10", "J", "Q", "K"];
const NAMES = ["Low Card", "High Card", "Even", "Odd", "Red", "Black"];

// Reference v-kvalmin / v-kvalmax: 1000 → "1K", 100000 → "1L"
export function formatRangeVal(val) {
  const n = Number(val);
  if (val == null || val === "" || Number.isNaN(n)) return "";
  if (n >= 100000) return `${parseFloat((n / 100000).toFixed(2))}L`;
  if (n >= 1000) return `${parseFloat((n / 1000).toFixed(2))}K`;
  return String(parseFloat(n.toFixed(2)));
}

// Market at reference index i (by `nat` first, then position)
export function lucky7Markets(sub = []) {
  const list = Array.isArray(sub) ? sub : [];
  const byNat = (name) => list.find((s) => String(s?.nat || "").toLowerCase() === name.toLowerCase());
  const names = [
    ...NAMES,
    ...CARD_VALUES.map((v) => `Card ${v === "A" ? "1" : v}`),
    "Line 1",
    "Line 2",
    "Line 3",
    "Line 4",
  ];
  return names.map((name, i) => byNat(name) || (name === "Card 1" && byNat("Card A")) || list[i] || { nat: name });
}

